import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tran-application-submitted',
    templateUrl: './application-submitted.html',
    imports: [RouterLink, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationSubmittedComponent {}
